type Order = '1' | '2' | '3';

export const setCopyOrder = (viewport: string): Order => {
  return viewport === 'Small' ? '3' : '2';
};
